import React, { Component, PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { Button, Icon, Popup, Loader, Dimmer } from 'semantic-ui-react'
import { SimpleForm } from '~/form'
import { createCaptionBurnJob } from '~/project/actions'

class BurnCaptions extends Component {
  state = {
    open: false,
  }

  renderForm = () => {
    let { interview, videos, caption, dispatch } = this.props

    let options = videos
      .map(v => ({
        value: v.getIn(['file', 'url']),
        label: v.getIn(['file', 'filename']),
      }))
      .toArray()

    let formFields = [
      {
        name: 'video',
        type: 'radios',
        label: 'Valitse video',
        options,
      },
    ]

    return (
      <SimpleForm
        fields={formFields}
        validation={{ video: ['required'] }}
        submitText="Polta tekstitys"
        prompt
        onSubmit={values => {
          dispatch(
            createCaptionBurnJob(
              interview.get('project_id'),
              interview.get('id'),
              caption.getIn(['file', 'url']),
              values.get('video')
            )
          )
          this.setState({
            open: false,
          })
        }}
      />
    )
  }

  render() {
    let { open } = this.state
    return (
      <Popup
        trigger={
          <span style={{ cursor: 'pointer', marginLeft: '10px' }}>
            <Icon name="closed captioning" /> Polta videoon
          </span>
        }
        content={this.renderForm()}
        style={{ margin: 0, padding: 0, borderRadius: 0, width: '500px' }}
        on="click"
        open={open}
        onOpen={() => this.setState({ open: true })}
        onClose={() => this.setState({ open: false })}
        position="top left"
      />
    )
  }
}

export default connect(state => ({
  project: state.activeProject,
}))(BurnCaptions)
